<template>
  <div class="row">
    <div class="col-12">
      <b-card header="Add new company" header-tag="h4" body-class="mb-3 pb-2">

        <ValidationObserver ref="newCompanyLeadForm" slim>
          <form role="form" @submit.prevent="">
            <div class="row">
              <!-- Company Name - Input -->
              <div class="col-xl-6 form-group">
                <label class="form-label" for="company_name">Company Name</label>
                <input type="text" v-model="company.company_name" id="company_name" name="company_name" class="form-input" @input="trading_name_input" autocomplete="off" autofocus>
                <div v-if="notEmptyObject(company_search_results) || searching_companies_house" class="companies_house_company_search"
                     v-click-outside="clear_company_search_result">
                  <div v-if="searching_companies_house && !notEmptyObject(company_search_results)">
                    <h5 class="m-2 mt-3 mb-3"><i class="fas fa-spinner fa-pulse"></i>&nbsp;&nbsp; Searching...</h5>
                  </div>
                  <ul v-else>
                    <li v-for="company in company_search_results">
                      <button @click.prevent="select_company(company.company_number, company.company_status)"
                              :class="[company.company_status === 'dissolved' ? 'disabled' : 'clickable']" :disabled="disabledHMRC(company.company_status)">
                        <span class="c_status" :class="[company.company_status === 'active' ? 'active' : '']">{{ company.company_status }}</span>
                        <span class="c_title">{{ company.title }}</span>
                        <span class="c_number">{{ company.company_number }}</span>
                        <span class="c_address_snippet">{{ company.address_snippet }}</span>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- Company LTD Number - Input -->
              <ValidationProvider rules="ltdCompNoValidate" v-slot="{errors, classes}" name="LTD Reg Number" tag="div" v-if="company_details_visible" class="col-xl-6 form-group">
                <label class="form-label" for="ltd_reg_number">LTD Registration Number</label>
                <input type="text" v-model="company.ltd_reg_number" id="ltd_reg_number" name="ltd_reg_number" class="form-input disabled" :class="classes" readonly>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <div v-if="company_details_visible" class="card_inset">
              <div class="row">
                <div class="col-12">
                  <h5 class="font-weight-bold">Registered Address</h5>
                  <hr class="mt-2 mb-3">
                </div>

                <div class="col-xl-4 form-group">
                  <label class="form-label" for="building">Building</label>
                  <input type="text" v-model="company_address.building" id="building" name="building" class="form-input">
                </div>
                <div class="col-xl-4 form-group">
                  <label class="form-label" for="street">Street</label>
                  <input type="text" v-model="company_address.street" id="street" name="street" class="form-input">
                </div>
                <div class="col-xl-4 form-group">
                  <label class="form-label" for="locality">Locality</label>
                  <input type="text" v-model="company_address.locality" id="locality" name="locality" class="form-input">
                </div>
                <div class="col-xl-4 form-group">
                  <label class="form-label" for="city_town">City / Town</label>
                  <input type="text" v-model="company_address.city_town" id="city_town" name="city_town" class="form-input">
                </div>
                <div class="col-xl-4 form-group">
                  <label class="form-label" for="county">County</label>
                  <input type="text" v-model="company_address.county" id="county" name="county" class="form-input">
                </div>
                <div class="col-xl-4 form-group">
                  <label class="form-label" for="postcode">Postcode</label>
                  <input type="text" v-model="company_address.postcode" id="postcode" name="postcode" class="form-input">
                </div>
              </div>
            </div>
            <div v-if="notEmptyObject(contacts)" class="card_inset mt-3">
              <div class="row">
                <div class="col-12">
                  <h5 class="font-weight-bold">Registered Officers (Active)</h5>
                  <hr class="mt-2 mb-3">
                </div>
                <div v-for="(contact, index) in contacts" :key="index" class="col-xl-4 col-md-6">
                  <div class="inset_card_inset">
                    <p class="font-weight-bold bp_color mb-0">{{ contact.job_title }}</p>
                    <h5 class="mb-1">{{ contact.full_name }}</h5>
                    <p class="mb-0">{{ contact.address.full }}</p>

                    <hr class="mt-2 mb-0">

                    <div class="row mt-3">
                      <ValidationProvider rules="email" v-slot="{errors, classes}" name="Email Address" tag="div" class="col-12 form-group">
                        <label class="form-label" :for="'email_' + index">Email</label>
                        <input type="email" v-model="contacts[index].email" :id="'email_' + index" :name="'email_' + index" class="form-input" :class="classes">
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>
                      <ValidationProvider rules="decimal|max:15" v-slot="{errors, classes}" name="Mobile" tag="div" class="col-xl-6 form-group">
                        <label class="form-label" :for="'mobile_' + index">Mobile Number</label>
                        <input type="text" v-model="contacts[index].mobile" :id="'mobile_' + index" :name="'mobile_' + index" class="form-input" :class="classes" maxlength="15">
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>
                      <ValidationProvider rules="decimal|max:15" v-slot="{errors, classes}" name="Mobile" tag="div" class="col-xl-6 form-group">
                        <label class="form-label" :for="'phone_' + index">Landline Number</label>
                        <input type="text" v-model="contacts[index].phone" :id="'phone_' + index" :name="'phone_' + index" class="form-input" :class="classes" maxlength="15">
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="showSubmitBtn" class="row mt-3 mb-2">
              <div class="col-xl-6">
                <button class="btn orcaBtn grey_bg w-100 mb-3" @click.prevent="save_lead_add_another" :disabled="save_add_another">
                  <span v-if="save_add_another" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Saving lead ...</span>
                  <span v-else>Save lead - Add another</span>
                </button>
              </div>
              <div class="col-xl-6">
                <button class="btn orcaBtn grey_bg w-100 mb-3" @click.prevent="new_company_lead_submit" :disabled="save_go_profile">
                  <span v-if="save_go_profile" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Saving lead ...</span>
                  <span v-else>Save lead - go to profile</span>
                </button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </b-card>
    </div>
  </div>
</template>
<script>
export default {
  name: 'create_company_house',
  components: {},
  data() {
    return {
      save_add_another: false,
      save_go_profile: false,
      // current signed in crm user details
      user: this.$store.state.auth.me,
      searching_companies_house: false,
      company_search_results: {},
      company: {
        primary_consultant_id: this.$store.state.auth.me.id,
        company_name: '',
        company_type: 'Prospect',
        company_type_update: this.$moment.utc().format('YYYY-MM-DD'),
        ltd_reg_number: null,
      },
      company_details_visible: false,
      company_address: {
        company_id: null,
        address_type: 41, // Company Address Type => 'Registered Office'
        building: null,
        street: null,
        locality: null,
        city_town: null,
        county: null,
        postcode: null,
        full: null
      },
      accounts_address: {
        company_id: null,
        address_type: 43, // Company accounts Address Type => 'Accounts'
        building: null,
        street: null,
        locality: null,
        city_town: null,
        county: null,
        postcode: null,
        full: null
      },
      contacts: {},
      awaitingTradingNameSearch: false,
      showSubmitBtn: false,
    }
  },
  watch: {
    'company.company_name'(company) {
      if (company === '') {
        this.company = {
          primary_consultant_id: this.$store.state.auth.me.id,
          company_name: '',
          company_type: 'Prospect',
          company_type_update: this.$moment.utc().format('YYYY-MM-DD'),
          ltd_reg_number: null,
        };
        this.company_details_visible = false;
        this.company_address = {
          company_id: null,
          address_type: 'Registered Office',
          building: null,
          street: null,
          locality: null,
          city_town: null,
          county: null,
          postcode: null,
          full: null
        };
        this.company_address = {
          company_id: null,
          address_type: 'Accounts',
          building: null,
          street: null,
          locality: null,
          city_town: null,
          county: null,
          postcode: null,
          full: null
        };
        this.company_search_results = {};
        this.contacts = {};
        this.awaitingTradingNameSearch = false;
        this.searching_companies_house = false;
        this.showSubmitBtn = false;
      }
    }
  },
  methods: {
    // Companies house search
    trading_name_input() {
      if (this.company.company_name !== '') {
        this.searching_companies_house = true;
        if (!this.awaitingTradingNameSearch) {
          setTimeout(() => {
            this.search_companies_house();
            this.awaitingTradingNameSearch = false;
          }, 1000);
        }
        this.awaitingTradingNameSearch = true;
      }
      else {
        this.searching_companies_house = false;
      }
    },
    search_companies_house() {
      if (this.company.company_name !== '') {
        axios.post(this.crmApiPath + 'hmrc/company/search', {company_name: this.company.company_name}).then(companies => this.company_search_results = companies.data);
      }
    },
    clear_company_search_result() {
      if (this.notEmptyObject(this.company_search_results)) {
        this.company_search_results = {};
        this.searching_companies_house = false;
        this.awaitingTradingNameSearch = false;
      }
    },
    disabledHMRC(status) {
      if (status === 'dissolved') {
        return true;
      }
    },
    // Reset the form back to initial state
    reset_form() {
      this.searching_companies_house = false;
      this.company_search_results = {};
      this.company = {
        primary_consultant_id: this.$store.state.auth.me.id,
        company_name: '',
        company_type: 'Prospect',
        company_type_update: this.$moment.utc().format('YYYY-MM-DD'),
        ltd_reg_number: null,
      };
      this.company_address = {
        company_id: null,
        address_type_id: 41, // Company Address Type => 'Registered Office'
        building: null,
        street: null,
        locality: null,
        city_town: null,
        county: null,
        postcode: null,
        full: null
      };
      this.accounts_address = {
        company_id: null,
        address_type_id: 43, // Company Address Type => 'Registered Office'
        building: null,
        street: null,
        locality: null,
        city_town: null,
        county: null,
        postcode: null,
        full: null
      };
      this.company_details_visible = false;
      this.awaitingTradingNameSearch = false;
      this.showSubmitBtn = false;
      this.contacts = {};
    },
    // retrieve data about selected company from HMRC Companies House search
    select_company(company_number, status) {
      if (status !== 'dissolved') {
        this.reset_form();
        axios.post(this.crmApiPath + 'hmrc/company/profile', {company_number: company_number}).then(company => {

          // check if company name exists -> go to profile if exists button -> else submit buttons
          axios.get(this.crmApiPath + 'company/check_if_exists/name', {params: {company_name: company.data.company_name}}).then(company_exists => {
            if (company_exists.data.length === 0) {
              this.company.company_name = company.data.company_name;
              this.company.ltd_reg_number = company.data.company_number;
              this.company_details_visible = true;
              if (company.data.registered_office_address.hasOwnProperty('address_line_1')) {
                this.company_address.building = company.data.registered_office_address.address_line_1;
                this.accounts_address.building = company.data.registered_office_address.address_line_1;
              }
              if (company.data.registered_office_address.hasOwnProperty('address_line_2')) {
                this.company_address.street = company.data.registered_office_address.address_line_2;
                this.accounts_address.street = company.data.registered_office_address.address_line_2;
              }
              if (company.data.registered_office_address.hasOwnProperty('locality')) {
                this.company_address.city_town = company.data.registered_office_address.locality;
                this.accounts_address.city_town = company.data.registered_office_address.locality;
              }
              if (company.data.registered_office_address.hasOwnProperty('region')) {
                this.company_address.county = company.data.registered_office_address.region;
                this.accounts_address.county = company.data.registered_office_address.region;
              }
              if (company.data.registered_office_address.hasOwnProperty('postal_code')) {
                this.company_address.postcode = company.data.registered_office_address.postal_code;
                this.accounts_address.postcode = company.data.registered_office_address.postal_code;
              }

              this.company_address.full = this.calc_nice_address(
                  this.company_address.building,
                  this.company_address.street,
                  this.company_address.locality,
                  this.company_address.city_town,
                  this.company_address.county,
                  this.company_address.postcode
              );
              this.accounts_address.full = this.calc_nice_address(
                  this.accounts_address.building,
                  this.accounts_address.street,
                  this.accounts_address.locality,
                  this.accounts_address.city_town,
                  this.accounts_address.county,
                  this.accounts_address.postcode
              );

              axios.post(this.crmApiPath + 'hmrc/company/officers', {company_number: company_number}).then(company_officers => {
                this.contacts = company_officers.data;
              });
              this.searching_companies_house = false;
              this.company_search_results = {};
              this.$nextTick(() => this.showSubmitBtn = true);
            }
            else {
              this.$snotify.confirm('', '', {
                closeOnClick: false,
                position: 'centerCenter',
                backdrop: 0.5,
                html: '<div class="snotifyToast__title">Company Exists</div>' +
                      '<div class="snotifyToast__body">' +
                      '<strong class="mb-2 d-block">' + company.data.company_name + '</strong>' +
                      'Already exists in the CRM' +
                      '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
                      '</div>',
                buttons: [
                  {
                    text: 'Go to Profile', action: (toast) => {
                      this.$snotify.remove(toast.id);
                      this.$store.commit('CURRENT_RECORD_COMPANY_ID', company_exists.data.id);
                      this.$nextTick(() => {
                        this.$tabs.close({
                                           path: this.$router.currentRoute.fullPath,
                                           to: '/company/record'
                                         });
                        this.$tabs.refresh('/company/record', true);
                      })
                    }
                  },
                  {
                    text: 'Add Another Lead', action: (toast) => {
                      this.company.company_name = null;
                      this.reset_form();
                      this.$snotify.remove(toast.id)
                    }
                  }
                ]
              });
            }
          });
        });
      }
    },
    // Function to save the contacts for a company
    save_contacts(company_id) {
      let promises = []
      for (let i = 0; i < this.contacts.length; i++) {
        promises.push(new Promise((complete) => {
          // check if contact address same as company registered office address
          this.contacts[i].address_same_as_company = this.company_address.full === this.contacts[i].address.full;
          // set required variables for saving contact
          this.contacts[i].company_id = company_id;
          this.contacts[i].log_by_type = 'App\\Models\\Users\\User';
          this.contacts[i].log_by_id = this.$store.state.auth.me.id;
          // save contact
          axios.post(this.crmApiPath + 'contact', this.contacts[i]).then(contact_id => {
            // Contact Address
            this.contacts[i].address.company_id = company_id;
            this.contacts[i].address.contact_id = contact_id.data;
            this.contacts[i].address.belongs_to_id = contact_id.data;
            this.contacts[i].address.contact_info_model_type = 'App\\Models\\Contact_Info\\Address';
            this.contacts[i].address.log_by_id = this.$store.state.auth.me.id;
            this.contacts[i].address.record_type = 'contact';
            axios.post(this.crmApiPath + 'contact_info/address', this.contacts[i].address).then(() => {
              let contact_promises = [];
              if (this.contacts[i].mobile !== '') {
                contact_promises.push(new Promise(resolve => {
                  let mobile = {
                    'company_id': company_id,
                    'contact_id': contact_id.data,
                    'belongs_to_id': contact_id.data,
                    'belongs_to_type': 'App\\Models\\Companies\\Contacts\\Contact',
                    'contact_info_model_type': 'App\\Models\\Contact_Info\\Phone',
                    'log_by_id': this.$store.state.auth.me.id,
                    'record_type': 'contact',
                    'phone_type_id': 57, // work mobile
                    'phone_number': this.contacts[i].mobile
                  }
                  axios.post(this.crmApiPath + 'contact_info/phone', mobile).then(() => resolve());
                }));
              }
              else {
                contact_promises.push(new Promise(resolve => resolve()));
              }
              if (this.contacts[i].phone !== '') {
                contact_promises.push(new Promise(resolve => {
                  let phone = {
                    'company_id': company_id,
                    'contact_id': contact_id.data,
                    'belongs_to_id': contact_id.data,
                    'belongs_to_type': 'App\\Models\\Companies\\Contacts\\Contact',
                    'contact_info_model_type': 'App\\Models\\Contact_Info\\Phone',
                    'log_by_id': this.$store.state.auth.me.id,
                    'record_type': 'contact',
                    'phone_type_id': 56, // work landline
                    'phone_number': this.contacts[i].phone
                  }
                  axios.post(this.crmApiPath + 'contact_info/phone', phone).then(() => resolve());
                }));
              }
              else {
                contact_promises.push(new Promise(resolve => resolve()));
              }
              if (this.contacts[i].email !== '') {
                contact_promises.push(new Promise(resolve => {
                  let email = {
                    'company_id': company_id,
                    'contact_id': contact_id.data,
                    'belongs_to_id': contact_id.data,
                    'belongs_to_type': 'App\\Models\\Companies\\Contacts\\Contact',
                    'contact_info_model_type': 'App\\Models\\Contact_Info\\Email',
                    'log_by_id': this.$store.state.auth.me.id,
                    'record_type': 'contact',
                    'email_type_id': 63, // work email
                    'email_address': this.contacts[i].email
                  }
                  axios.post(this.crmApiPath + 'contact_info/email', email).then(() => resolve());
                }));
              }
              else {
                contact_promises.push(new Promise(resolve => resolve()));
              }
              contact_promises.push(new Promise(resolve => {
                let job_title_id = null;
                if (this.contacts[i].job_title_id !== null) {
                  job_title_id = this.contacts[i].job_title_id.id
                }
                let contact_profile = {
                  'contact_id': contact_id.data,
                  'job_title_id': job_title_id,
                  'company_id': company_id,
                  'log_by_type': 'App\\Models\\Users\\User',
                  'log_by_id': this.$store.state.auth.me.id
                }
                axios.post(this.crmApiPath + 'contact/profile', contact_profile).then(() => resolve());
              }));
              Promise.all(contact_promises).then(() => complete());
            });
          });
        }));
      }
      return Promise.all(promises)
    },
    // SUBMIT FUNCTIONS
    save_company_company(type) {
      // Set log values for creating the worker (current crm user)
      this.company.log_by_type = 'App\\Models\\Users\\User';
      this.company.log_by_id = this.user.id;

      return axios.post(this.crmApiPath + 'company', this.company).then(company_id => {
        let company_profile = {
          'log_by_type': 'App\\Models\\Users\\User',
          'log_by_id': this.$store.state.auth.me.id,
          'company_id': company_id.data,
          'ltd_reg_number': this.company.ltd_reg_number
        };
        axios.post(this.crmApiPath + 'company/profile', company_profile).then(() => {
          this.save_contacts(company_id.data).then(() => {
            this.accounts_address.company_id = company_id.data;
            this.accounts_address.belongs_to_id = company_id.data;
            this.accounts_address.belongs_to_type = 'App\\Models\\Companies\\Company';
            this.accounts_address.contact_info_model_type = 'App\\Models\\Contact_Info\\Address';
            this.accounts_address.address_type_id = 43;
            this.accounts_address.log_by_id = this.$store.state.auth.me.id;
            this.accounts_address.record_type = 'company';
            axios.post(this.crmApiPath + 'contact_info/address', this.accounts_address).then(() => {
              this.company_address.company_id = company_id.data;
              this.company_address.belongs_to_id = company_id.data;
              this.company_address.belongs_to_type = 'App\\Models\\Companies\\Company';
              this.company_address.contact_info_model_type = 'App\\Models\\Contact_Info\\Address';
              this.company_address.address_type_id = 41;
              this.company_address.log_by_id = this.$store.state.auth.me.id;
              this.company_address.record_type = 'company';
              axios.post(this.crmApiPath + 'contact_info/address', this.company_address).then(() => {
                this.$snotify.success(this.company.company_name + ' added to CRM ');

                if (type === 'add_another') {
                  this.$nextTick(() => {
                    this.company.company_name = null;
                    this.reset_form()
                    this.save_add_another = false;
                  })
                }
                else if (type === 'go_to_profile') {
                  this.$store.commit('CURRENT_RECORD_COMPANY_ID', company_id.data);
                  this.$store.commit('SET_COMPANY_TAB_INDEX', 0);
                  this.$nextTick(() => {
                    this.save_go_profile = false;
                    this.$tabs.close({
                                       path: this.$router.currentRoute.fullPath,
                                       to: '/company/record'
                                     });
                    this.$tabs.refresh('/company/record', true);
                  });
                }
              });
            })
          })
        })
      });
    },
    // button functions
    save_lead_add_another() {
      this.save_add_another = true;
      this.save_company_company('add_another')
    },
    new_company_lead_submit() {
      this.save_go_profile = true;
      this.save_company_company('go_to_profile')
    }
  },
  beforeDestroy() {
    this.save_add_another = false;
    this.save_go_profile = false;
    this.searching_companies_house = false;
    this.company_search_results = {};
    this.company_details_visible = false;
    this.contacts = {};
    this.awaitingTradingNameSearch = false;
    this.showSubmitBtn = false;
  }
}
</script>
<style scoped lang="scss">
.companies_house_company_search {
  position:                   absolute;
  background:                 $card_background;
  border:                     1px solid $card_background;
  border-bottom-left-radius:  $border_radius;
  border-bottom-right-radius: $border_radius;
  box-shadow:                 0 1px 5px 0 rgba($bc_2, 0.5);
  z-index:                    99;
  max-height:                 230px;
  overflow-y:                 scroll;
  width:                      100%;

  ul {
    list-style-type: none;
    padding-left:    0;
    margin-bottom:   0;

    li {
      button {
        padding:    7.5px 10px;
        border:     none;
        width:      100%;
        text-align: left;
        background: none;

        &.disabled {
          background: lighten($bc_5, 0%);
        }

        .c_status, .c_title, .c_number, .c_address_snippet {
          display:     block;
          width:       100%;
          line-height: 1;
        }

        .c_status, .c_number {
          margin-bottom: 2.5px;
        }

        .c_status {
          text-transform: capitalize;
          color:          $red;
          font-size:      0.65rem;

          &.active {
            color: #008000;
          }
        }

        .c_title {
          font-weight:   bold;
          margin-bottom: 1.5px;
          color:         $bc_2;
          font-size:     0.85rem;
        }

        .c_number {
          font-size: 0.7rem;
        }

        .c_address_snippet {
          font-size: 0.6rem;
          color:     $bc_3;
        }

        &.clickable {
          &:hover, &:focus, &:active, &:active:focus, &.active:focus,
          &.focus, &:active.focus, &.active.focus {
            background: lighten($bc_5, 12.5%);
            outline:    none;
          }
        }

      }

      border-bottom: 1px solid $bc_2;

      &:last-of-type {
        border-bottom: none;

        button {
          border-bottom-left-radius:  $border_radius;
          border-bottom-right-radius: $border_radius;
        }
      }
    }

  }
}

.card_inset {
  padding:    10px 12px 5px 12px;
  background: darken($card_background, 2.5%);

  .inset_card_inset {
    padding:       10px 12px 10px 12px;
    background:    $card_background;
    margin-bottom: 10px;
  }
}
</style>
<style lang="scss"></style>
